export const tableData = {
    massActions: [
        {
            text: "Edytuj",
            icon: "edit",
            action: "fas fa-edit",
            class: "btn btn-info mass-operations-btn",
            enabled: true,
        },
        {
            text: "Usuń",
            icon: "fas fa-trash-alt",
            action: "delete",
            class: "btn btn-danger mass-operations-btn",
            enabled: true,
        },
    ],
    headers: {
        fieldNameId: {
            text: "ID",
            key: "fieldNameId",
            type: "number",
            sortable: true,
            style: "cursor:pointer;width:5%",
        }, // available types: number, string, date,datetime,array,boolean,actions,button
        fieldNameTitle: {
            text: "Tytuł",
            key: "fieldNameTitle",
            type: "text",
            sortable: true,
            style: "cursor:pointer;width:15%",
        },
        fieldNameContent: {
            text: "Treść",
            key: "fieldNameContent",
            type: "text",
            sortable: true,
            style: "cursor:pointer;width:70%",
        },
        actions: {
            text: "Akcje",
            key: "actions",
            type: "actions",
            style: "cursor:pointer;width:10%",
            actions: [
                {
                    text: "Edytuj",
                    icon: "edit",
                    action: "edit",
                    class: "btn btn-info table-actions-button edit-button",
                    enabled: true,
                },
                {
                    text: "Usuń",
                    icon: "trash-alt",
                    action: "delete",
                    class: "btn btn-danger table-actions-button edit-button",
                    enabled: true,
                },
            ],
        },
    },
    data: [
        {
            fieldNameId: 1,
            fieldNameTitle: "Tytuł 1",
            fieldNameContent: "Treść 1",
        },
        {
            fieldNameId: 2,
            fieldNameTitle: "Tytuł 2",
            fieldNameContent: "Treść 2",
        },
        {
            fieldNameId: 3,
            fieldNameTitle: "Tytuł 3",
            fieldNameContent: "Treść 3",
        },
        {
            fieldNameId: 4,
            fieldNameTitle: "Tytuł 4",
            fieldNameContent: "Treść 4",
        },
        {
            fieldNameId: 5,
            fieldNameTitle: "Tytuł 5",
            fieldNameContent: "Treść 5",
        },
        {
            fieldNameId: 6,
            fieldNameTitle: "Tytuł 6",
            fieldNameContent: "Treść 6",
        },
        {
            fieldNameId: 7,
            fieldNameTitle: "Tytuł 7",
            fieldNameContent: "Treść 7",
        },
        {
            fieldNameId: 8,
            fieldNameTitle: "Tytuł 8",
            fieldNameContent: "Treść 8",
        },
        {
            fieldNameId: 9,
            fieldNameTitle: "Tytuł 9",
            fieldNameContent: "Treść 9",
        },
        {
            fieldNameId: 10,
            fieldNameTitle: "Tytuł 10",
            fieldNameContent: "Treść 10",
        },
        {
            fieldNameId: 11,
            fieldNameTitle: "Tytuł 11",
            fieldNameContent: "Treść 11",
        },
        {
            fieldNameId: 12,
            fieldNameTitle: "Tytuł 12",
            fieldNameContent: "Treść 12",
        },
        {
            fieldNameId: 13,
            fieldNameTitle: "Tytuł 13",
            fieldNameContent: "Treść 13",
        },
        {
            fieldNameId: 14,
            fieldNameTitle: "Tytuł 14",
            fieldNameContent: "Treść 14",
        },
        {
            fieldNameId: 15,
            fieldNameTitle: "Tytuł 15",
            fieldNameContent: "Treść 15",
        },
        {
            fieldNameId: 16,
            fieldNameTitle: "Tytuł 16",
            fieldNameContent: "Treść 16",
        },
        {
            fieldNameId: 17,
            fieldNameTitle: "Tytuł 17",
            fieldNameContent: "Treść 17",
        },
    ],
};
